export default __webpack_public_path__ + "static/media/photo4.5d44b7d0.jpeg";